import { useQuery } from "react-query";
import { getWrapUpNoteDetails } from "../../../api/services";

export const useWrapUpNoteDetails = (
  accountNumber: string,
  wrapUpNoteId: string,
) => {
  return useQuery(
    ["accounts/wrapupnote", { accountNumber, wrapUpNoteId }],
    getWrapUpNoteDetails,
    {
      enabled: !!accountNumber && !!wrapUpNoteId,
    },
  );
};
